export default __webpack_public_path__ + "static/media/mail.d8ebf233.svg";